import React, {PropsWithChildren, ReactNode} from "react";
import classNames from "classnames";
import {SVVConditionalWrapper} from "./ConditionalWrapper";

type LayoutBannerProps = PropsWithChildren<{
  /** Secondary gir grå bakgrunn dersom den er satt til true, og hvit bakgrunn om den er satt til false */
  secondary?: boolean;
  medium?: boolean;
  noPaddingTop?: boolean;
}>;

export function SVVLayoutBanner({ secondary = false, noPaddingTop = false, medium = false, children }: LayoutBannerProps) {
  return (
    <div
      className={`svv-layout__banner ${  classNames({
        "svv-layout__banner--primary": !secondary,
        "svv-layout__banner--secondary": secondary,
        "svv-layout__banner--no-padding-top": noPaddingTop,
      })}`}
    >
      <div className="svv-layout__content">
        <SVVConditionalWrapper
          condition={medium}
          // eslint-disable-next-line  @typescript-eslint/no-shadow
          renderWrapper={(children: ReactNode) => (
            <div className="svv-layout__content__medium">{children}</div>
          )}
        >
          {children}
        </SVVConditionalWrapper>
      </div>
    </div>
  );
}

SVVLayoutBanner.displayName = "SVVLayoutBanner";
